var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"regular_box"},[_c('NavBar',{attrs:{"headtitle":'交易行规则'}}),_c('div',{staticClass:"content_box"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.regularData.title)}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.regularData.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }